import { createPathExpression } from 'modules/handlebars/domain/expression/utils';
import { createHash } from 'modules/handlebars/domain/hash/utils';
import { MustacheStatementSerializer } from 'modules/handlebars/domain/statement/serializer/mustache';
import { createMustacheStatement } from 'modules/handlebars/domain/statement/utils';

export const serializeMergeTag = (fieldName: string) => {
  const fieldPath = createPathExpression(fieldName);
  const fieldReference = createMustacheStatement({
    path: fieldPath,
    hash: createHash(),
    params: [],
  });
  const serializedFieldReference = MustacheStatementSerializer.serialize(fieldReference);
  return serializedFieldReference;
};
